module.exports = __webpack_public_path__ + "static/media/dialogduk.a3521d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Om/static/dialogduk.png
// module id = 153
// module chunks = 0